module.exports = __webpack_public_path__ + "static/horizontal-logo-97c56c077af0b69baea9c541a2442a42.png";